import { css } from 'styled-components';
import { standardColorScheme } from './colorSchemes';
import baseAliasCssContent from './baseAlias.css';
import colorAliasCssContent from './colorAlias.css';

export const baseAliasTokens = css`
  ${baseAliasCssContent}
`;

export const colorAliasTokens = css`
  --wui-color-bg-app: var(--wui-app-background);
  ${standardColorScheme}
  ${baseAliasTokens}
  ${colorAliasCssContent}
`;
